<form-input-regex
  id="txtLetters"
  inputmode="numeric"
  [type]="masked ? 'password' : 'text'"
  [(ngModel)]="value"
  (ngModelChange)="onChange()"
  #input="ngModel"
  [regex]="regexNumbers"
  [label]="label"
  [required]="required"
  [disabled]="disabled"
  [maxlength]="maxlength"
  [placeholder]="placeholder"
  (blur)="onBlur()"
  [flag]="flag"
  [hasError]="hasError"
></form-input-regex>
